import * as CryptoJS from 'crypto-js';

import { serializeString } from './serialize-string';

export function encryptData(data: any, passphrase: string) {
  const encryptionKey = CryptoJS.enc.Utf8.parse(passphrase);
  const iv = CryptoJS.lib.WordArray.random(16);
  const serializedData = serializeString(JSON.stringify(data));
  const encryptedData = CryptoJS.AES.encrypt(serializedData, encryptionKey, { iv }).toString();

  const base64Iv = iv.toString(CryptoJS.enc.Base64);
  const mac = CryptoJS.HmacSHA256(base64Iv + encryptedData, encryptionKey);

  return btoa(
    JSON.stringify({
      iv: base64Iv,
      value: encryptedData,
      mac: mac.toString(CryptoJS.enc.Hex),
      tag: ''
    })
  );
}
